import { render, staticRenderFns } from "./handleBtn.vue?vue&type=template&id=5adf1ef2&scoped=true&"
import script from "./handleBtn.vue?vue&type=script&lang=js&"
export * from "./handleBtn.vue?vue&type=script&lang=js&"
import style0 from "./handleBtn.vue?vue&type=style&index=0&id=5adf1ef2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adf1ef2",
  null
  
)

export default component.exports